import { Button, Col, DatePicker, Divider, Empty, Form, FormInstance, InputNumber, FormProps, Input, Row } from "antd";
import { Movimentacao } from "../../../../../Models/Financeiro/Conta/Movimentacao";
import MovimentacaoTableBasic, { IMovimentacaoTableBasicProps } from "./MovimentacaoTableBasic";
import ComponentePermissao from "../../../../Base/Permissao/ComponentePermissao";
import { Link } from "react-router-dom";
import MovFormaPagamentoSelect from "./MovFormaPagamento/MovFormaPagamentoSelect";
import { useMovimentacaoListarPagina, useMovimentacaoListar } from "../../../../../Services/Financeiro/Conta/MovimentacaoService";
import dayjs, { Dayjs } from 'dayjs';
import { useState } from "react";
import Utilitario from "../../../../../Utils/Utilitario";
// import { useState } from "react";
import ContaSelect from "../ContaSelect";
import Pagina, { IPaginaInfo, PaginaInfo } from "@/Models/Utils/Pagina/Pagina";
import CarregamentoComponentes from "@/Components/Base/Carregamento";

import { SelectComPesquisa } from "@/Components/SelectComPesquisa";
import InputRangePicker from "@/Components/Base/Input/InputRangePicker";

export interface IMovimentacaoTableBasicFormType {
    pagina?:IPaginaInfo;
    movimentacao?:Movimentacao|null;
    intervalo?:[Dayjs|undefined, Dayjs|undefined];
    entrada?:boolean|null;
    ativo?:boolean|null;
}

export interface IMovimentacaoConsultaScreenProps extends FormProps<IMovimentacaoTableBasicFormType> {
    tableProps?:Omit<IMovimentacaoTableBasicProps, "dataSource">;
}

export default function MovimentacaoConsultaScreen({
    form : formParam,
    initialValues,
    tableProps,
    component,
    layout,
    ...rest
}:IMovimentacaoConsultaScreenProps) {
    const dataAtual = new Date();
    const [newForm] = Form.useForm<IMovimentacaoTableBasicFormType>();
    const form = formParam ?? newForm;
    const inputRequest = Form.useWatch([], form);
    const [ consultar, setConsultar ] = useState(false);

    const {
        data,
        isLoading,
        isSuccess,
        isError,
        refetch
    } = useMovimentacaoListarPagina({
        ...(inputRequest as Omit<IMovimentacaoTableBasicFormType, "intervalo">),
        pagina : inputRequest?.pagina ?? new Pagina(),
        dataInicial : inputRequest?.intervalo?.[0]?.toDate(),
        dataFinal : inputRequest?.intervalo?.[1]?.toDate(),
        enabled : consultar,
        onFinish() {
            setConsultar(false);
        }
    });

    const todasMovimentacoesQuery = useMovimentacaoListar({
        ...(inputRequest as Omit<IMovimentacaoTableBasicFormType, "intervalo">),
        dataInicial : inputRequest?.intervalo?.[0]?.toDate(),
        dataFinal : inputRequest?.intervalo?.[1]?.toDate(),
        enabled : false
    });

    return <Form
        {...rest}
        form={form}
        component={component === undefined ? "div" : component}
        layout={layout === undefined ? "vertical" : layout}
        initialValues={{
            ...initialValues,
            pagina : initialValues?.pagina === undefined ? new PaginaInfo() : initialValues?.pagina,
            ativo : initialValues?.ativo === undefined ? true : initialValues.ativo,
            movimentacao : initialValues?.movimentacao === undefined ? {} as Movimentacao : initialValues?.movimentacao,
            intervalo : [ dayjs(new Date(dataAtual.getFullYear(), dataAtual.getMonth(), 1)), dayjs(new Date()) ],
            entrada: undefined
        }}
        onFinish={(data) => {
            form.setFieldsValue({
                pagina : {
                    pagina : 1
                }
            } as any);
            //refetch();
            setConsultar(true);
        }}
    >
        <Row gutter={8} wrap>
            <Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={4}>
                <Form.Item<IMovimentacaoTableBasicFormType> hidden name={["ativo"]}></Form.Item>
                <Form.Item<IMovimentacaoTableBasicFormType> hidden name={["pagina"]}></Form.Item>
                {/* rules={[
                    {
                        required : true
                    },
                    {
                        validator(rule, value:[Dayjs|undefined, Dayjs|undefined], callback) {
                            if (value?.[0] === undefined || value?.[1] === undefined || Utilitario.diferancaEntreDatas(value[0].toDate(), value[1].toDate()) > 92)
                                return Promise.reject(new Error("Por favor, informe um intervalo de no máximo 93 dias."));
                                
                            return Promise.resolve();
                        }
                    }
                ]} */}
                <Form.Item<IMovimentacaoTableBasicFormType> label="Intervalo" name={"intervalo"}>
                    <InputRangePicker />
                </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={4}>
                <Form.Item<IMovimentacaoTableBasicFormType> name={["entrada"]} label="Mov.">
                    <SelectComPesquisa
                        allowClear={true}
                        placeholder="Todas"
                        options={[
                            {
                                label : "Entrada",
                                value : true
                            },
                            {
                                label : "Saída",
                                value : false
                            }
                        ]}
                    />
                </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={4}>
                <Form.Item<IMovimentacaoTableBasicFormType> name={["movimentacao", "codConta"]} label="Conta">
                    <ContaSelect />
                </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={4}>
                <Form.Item<IMovimentacaoTableBasicFormType> name={["movimentacao", "codMovFormaPagamento"]} label="Forma">
                    <MovFormaPagamentoSelect />
                </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={4}>
                <Form.Item<IMovimentacaoTableBasicFormType> name={["movimentacao", "identificadorBanco"]}  label="ID. Transaçao" rules={[ { max : 50 } ]}>
                    <Input />
                </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={4}>
                <Form.Item<IMovimentacaoTableBasicFormType> name={["movimentacao", "codTitulo"]}  label="Título">
                    <InputNumber />
                </Form.Item>
            </Col>
        </Row>

        <Row gutter={8} wrap>
            <ComponentePermissao permissoes={["FinanceiroContaMovimentacaoListarTodos"]}>
                <Col xs={"auto"}>
                    <Button type="primary" loading={isLoading} onClick={() => form.submit()}>
                        Listar
                    </Button>
                </Col>
            </ComponentePermissao>
            <ComponentePermissao permissoes={["FinanceiroContaMovimentacaoInserir"]}>
                <Col xs={"auto"}>
                    <Link to={"Novo"}>
                        <Button type="primary">Adicionar</Button>
                    </Link>
                </Col>
            </ComponentePermissao>
        </Row> 
        {
            (isSuccess || isLoading) && <>
                <Divider>Registros</Divider>
                <ComponentePermissao permissoes={["FinanceiroContaMovimentacaoListarTodos"]}>
                    <CarregamentoComponentes.TelaCarregamento ativo={isLoading || !!tableProps?.loading}>
                        <MovimentacaoTableBasic {...tableProps} onChange={(pagina, ...restParam) => {
                            form.setFieldsValue({
                                pagina : {
                                    pagina : pagina.current ?? 1,
                                    tamanho : pagina.pageSize ?? 15
                                }
                            } as any);

                            setConsultar(true);
                        }} dataSource={data} 
                        csv={{
                            enabled: true,
                            filename: "Movimentacoes.csv",
                            acquireSource: async () => {
                                const todasMovimentacoes = await todasMovimentacoesQuery.refetch().then((r) => r)
                                return todasMovimentacoes.data ?? [];
                            }
                        }}
                    />
                    </CarregamentoComponentes.TelaCarregamento>
                </ComponentePermissao>
            </> || <>
                <Empty description={isError ? "Ocorreu um erro, tente novamente!" : "Clique em \"Listar\" para realizar a consulta."} />
            </>
        }
    </Form>;
}
